import { z } from "zod";
export const ElementViewBaseColumnType = z.enum([
    "Name",
    "Description",
    "Value",
    "UpdatedAt",
]);
export const ElementViewColumnType = z.union([
    z.literal("BaseProperty"),
    z.literal("PropertyDefinition"),
    z.literal("Theme"),
]);
export const ElementViewColumnSharedAttributes = z.object({
    id: z.string(),
    persistentId: z.string(),
    elementDataViewId: z.string(),
    sortPosition: z.number(),
    width: z.number(),
});
export const ElementViewBasePropertyColumn = ElementViewColumnSharedAttributes.extend({
    type: z.literal("BaseProperty"),
    basePropertyType: ElementViewBaseColumnType,
});
export const ElementViewPropertyDefinitionColumn = ElementViewColumnSharedAttributes.extend({
    type: z.literal("PropertyDefinition"),
    propertyDefinitionId: z.string(),
});
export const ElementViewThemeColumn = ElementViewColumnSharedAttributes.extend({
    type: z.literal("Theme"),
    themeId: z.string(),
});
export const ElementViewColumn = z.discriminatedUnion("type", [
    ElementViewBasePropertyColumn,
    ElementViewPropertyDefinitionColumn,
    ElementViewThemeColumn,
]);
